import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import { useRequestIds } from '~/context/srp/InventoryContext';

export default function useAddMetaAttributes() {
  const { updateMetaAttributes } = useContext(AnalyticsContext);
  const { previousSearchRequestId, searchRequestId } = useRequestIds();

  useEffect(() => {
    updateMetaAttributes({
      currentSearchRequestId: searchRequestId,
      previousSearchRequestId
    });
  }, [previousSearchRequestId, searchRequestId, updateMetaAttributes]);

  useEffect(() => {
    return () => {
      updateMetaAttributes(prev => {
        const {
          currentSearchRequestId: ignoredCurrentSearchRequestId,
          previousSearchRequestId: ignoredPreviousSearchRequestId,
          ...rest
        } = prev;

        return rest;
      });
    };
  }, [updateMetaAttributes]);
}
